import type {ReactNode} from 'react'
import {stickyFooterWrapper} from './sticky-footer.module.scss'

type Props = {
  bottom?: number
  children: ReactNode
  className?: string | null
}

export function StickyFooter(props: Props) {
  const {bottom = 0, className, children} = props

  const classNameStr = className ?? ''
  const newClassName = `${stickyFooterWrapper} ${classNameStr}`

  return (
    <div data-test="sticky-footer" style={{bottom}} className={newClassName}>
      {children}
    </div>
  )
}
